<template>
  <div>
    <v-tabs
    v-model="tab"
    color="primary"
    dark
    fixed-tabs
    grow height="40"
    >
    <v-tabs-slider></v-tabs-slider>
    <v-tab v-for="tabitem in tabitems" :key="tabitem">
      {{ tabitem }}
    </v-tab>
  </v-tabs>
  <v-tabs-items v-model="tab">
    <v-tab-item :key="0">
      <v-container class="pa-0" grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card flat>
              <v-flex xs12 sm9 mx-auto>
                <v-form ref="frmPersonal" @submit.prevent="validateAndSave()">
                  <v-card flat>
                    <div style="position:absolute; top:20px; right:20px">
                      <v-avatar :size="120" class="grey lighten-4">
                        <img v-if="avatarURL" :src="avatarURL">
                        <v-icon color="grey" size="110px" v-else>person</v-icon>
                      </v-avatar>
                      <br />
                      <input style="display:none" type="file" ref="fileInput"
                      accept="image/*" @change="loadAvatarFromFile"/>
                      <v-btn class="ml-3" icon @click="pickAvatar"><v-icon small>edit</v-icon></v-btn>
                      <v-btn icon @click="prepareCamera"><v-icon small>photo_camera</v-icon></v-btn>
                    </div>
                    <v-card-text class="pa-2">
                      <v-flex xs6>
                        <v-text-field
                        label="Name"
                        v-model="profile.cust_name"
                        :rules="[rules.required]"
                        maxlength="50"
                        ></v-text-field>
                        <v-select
                        label="Gender"
                        :items="['Male', 'Female']"
                        v-model="profile.gender"
                        :rules="[rules.required]"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <vue-tel-input-vuetify
                        ref="refMob"
                        v-model="profile.contact_phone"
                        label="Mobile number"
                        placeholder="Enter a mobile number"
                        @keydown.native="ignoreBackspace"
                        @input="keepCursor"
                        :rules="[rules.required]"
                        :input-options="{showDialCode: true}"
                        @validate="validateMob"
                        />
                      </v-flex>
                      <v-flex xs12 class="warning px-2 pt-2 mb-2" v-if="config.MOBILE_NO !== this.profile.contact_phone">
                        <v-layout row wrap>
                          <v-flex xs12 class="caption">Mobile number change deducted. Press send OTP after changing the number to get it validated.</v-flex>
                          <v-flex xs6>
                            <v-text-field
                            v-model="otp" class="pt-0"
                            type="number"
                            placeholder="Enter OTP" :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 class="text-xs-right">
                            <v-btn flat class="mt-0" @click="sendOTP">Send OTP</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-layout row v-if="config.MOBILE_NO !== this.profile.contact_phone">
                        <v-flex xs6>

                        </v-flex>
                      </v-layout>
                      <v-flex xs12>
                        <v-text-field
                        label="E-mail"
                        v-model="profile.contact_email"
                        :rules="[rules.required, rules.email]"
                        maxlength="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-checkbox :disabled="isMC || isFM"
                        label="Hide contact info from others"
                        v-model="hideContact"
                        hint="Not possible if you are a MC member or FM ;)"
                        persistent-hint
                        outline
                        class="mt-0 py-0 mb-3"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs12>
                        <span class="primary--text">Other Information</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs6>
                            <v-text-field
                            label="Emergency phone"
                            v-model="profile.emergency_phone"
                            hide-details
                            maxlength="15"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                            label="Contact name"
                            v-model="profile.emergency_contact_name"
                            hide-details
                            maxlength="25"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-combobox
                            label="Contact relationship"
                            v-model="profile.emergency_contact_relation"
                            :items="['Spouse','Father','Mother','Son','Daughter']"
                            maxlength="15"
                            hide-details
                            ></v-combobox>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                            label="Blood group"
                            v-model="profile.blood_group"
                            hide-details
                            maxlength="10"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                            label="Occupation"
                            v-model="profile.occupation"
                            hide-details
                            maxlength="15"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                            label="Hobbies"
                            v-model="profile.hobbies"
                            maxlength="50"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12>
                        <span class="primary--text">Address</span>
                      </v-flex>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <v-text-field
                            label="Address"
                            v-model="profile.address"
                            hide-details
                            maxlength="150"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                            label="City"
                            v-model="profile.city"
                            hide-details
                            maxlength="25"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                            :label="config.COMM_COUNTRY_CODE === 'MY'? 'Postal Code' : 'PIN Code'"
                            v-model="profile.pin_code"
                            hide-details
                            maxlength="10"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                            label="State"
                            v-model="profile.state"
                            maxlength="25"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                            label="Country"
                            v-model="profile.country"
                            maxlength="50"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 v-if="config.IS_TAX_APP">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <span class="primary--text">Tax Information</span>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-text-field
                            label="GST Identification No."
                            v-model="profile.gst_no"
                            hide-details
                            maxlength="15"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <div v-if="isMC || isAdmin" class="mt-3 mx-auto">
                        <v-chip v-if="isMC" color="primary white--text" disabled><v-icon left>star</v-icon>{{ roleName }}</v-chip>
                        <v-chip v-if="isAdmin" color="primary white--text" disabled><v-icon left>supervisor_account</v-icon>Admin</v-chip>
                      </div>
                    </v-card-text>
                    <v-card-actions class="pt-0">
                      <v-spacer></v-spacer>
                      <v-btn @click.native="canSendOTP=false, cancelChanges()">Cancel</v-btn>
                      <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-tab-item>

    <v-tab-item :key="1" v-if="!config.IS_OTHER_USER">
      <v-container class="pa-0">
        <v-layout>
          <v-flex xs12>
            <v-form ref="frmUnit" @submit.prevent="validateAndSave()">
              <v-card flat v-for="(unit, i) in config.UNITS" :key="i">
                <v-card-title class="primary lighten-2">
                  <v-container grid-list-md class="pa-0">
                    <v-layout row wrap>
                      <v-flex xs12 class="white--text title">
                        {{ commName }}
                      </v-flex>
                      <v-flex xs12 class="yellow--text subheading">
                        {{ unit.block_nm + ' ' + unit.unit_no }} <span v-if="unit.bhk || unit.acc_sqft">- <span v-if="unit.bhk">{{ unit.bhk }} BHK, </span><span v-if="unit.acc_sqft">{{ unit.acc_sqft }} sqft </span></span>({{ unit.ownership }})
                      </v-flex>
                      <v-flex xs6 sm3 md2>
                        <v-switch class="ma-0"
                        label="Rented out"
                        v-model="unit.is_rented"
                        hide-details
                        @change="saveChanges(unit, true)"
                        :disabled="unit.ownership.toLowerCase().includes('tenant')"
                        ></v-switch>
                      </v-flex>
                      <v-flex xs6>
                        <v-switch class="ma-0"
                        :label="'Bill to tenant' + (users[unit.unit_id] && users[unit.unit_id].findIndex(rec => rec.ownership.toLowerCase().includes('tenant')) === -1 && unit.is_rented ? ' (No tenant info available)' : '')"
                        v-model="unit.is_billed_to_tenant"
                        hide-details
                        :disabled="unit.ownership.toLowerCase().includes('tenant') || (users[unit.unit_id] && users[unit.unit_id].findIndex(rec => rec.ownership.toLowerCase().includes('tenant')) === -1 || !unit.is_rented)"
                        @change="saveChanges(unit)"
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-title>
                <v-card class="ma-2">
                  <v-card-title class="pa-2 grey lighten-4">
                    <div class="title grey--text">Integra users from this unit</span></div>
                  </v-card-title>
                  <v-data-table
                  :headers="$vuetify.breakpoint.smAndUp?userHeadSm:userHead"
                  :items="users[unit.unit_id]"
                  hide-actions
                  >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td v-if="$vuetify.breakpoint.smAndUp"><v-avatar size="36px" slot="activator">
                        <img :src="config.STATIC_FILES_DIR + props.item.avatar_url"/>
                      </v-avatar>
                    </td>
                    <td>
                      {{ props.item.cust_name }}
                    </td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.contact_phone }}</td>
                    <td> {{ props.item.ownership }} </td>
                    <td>{{ !props.item.is_active ? 'Disabled': props.item.rel_status }}
                    </td>
                    <v-menu bottom left class="mt-2" v-if="!unit.ownership.toLowerCase().includes('tenant')">
                      <v-btn small icon slot="activator" class="ma-0">
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                      <v-list>
                        <v-list-tile v-if="props.item.rel_status === 'Pending Approval' || props.item.rel_status === 'Rejected'" @click="acceptRejReq('accept-req', props.item, unit)">
                          <v-list-tile-avatar><v-icon>check</v-icon></v-list-tile-avatar>
                          <v-list-tile-title>Approve request</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-if="props.item.rel_status === 'Pending Approval'" @click="acceptRejReq('reject-req', props.item, unit)">
                          <v-list-tile-avatar><v-icon>close</v-icon></v-list-tile-avatar>
                          <v-list-tile-title>Reject request</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-if="props.item.rel_status === 'Linked'" @click="userUpdate('delink', props.item, unit)">
                          <v-list-tile-avatar><v-icon>close</v-icon></v-list-tile-avatar>
                          <v-list-tile-title>Delink from this unit</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile v-else-if="props.item.rel_status === 'Delinked'" @click="userUpdate('link', props.item, unit)">
                          <v-list-tile-avatar><v-icon>link</v-icon></v-list-tile-avatar>
                          <v-list-tile-title>Link to this unit</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </tr>
                </template>
              </v-data-table>
            </v-card>

            <!-- <v-card class="ma-2">
            <v-card-title class="pa-2 grey lighten-4">
            <div class="title grey--text">
            <span>Occupancy information</span>
            <v-btn small class="mb-0 mt-0">Add new</v-btn>
          </div>
        </v-card-title>
        <v-data-table
        :headers="$vuetify.breakpoint.smAndUp?occHeadSm:userHead"
        :items="occupants"
        hide-actions
        >
        <template slot="items" slot-scope="props">
        <tr>
        <td>
        {{ props.item.occ_name }}
      </td>
      <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.contact_phone }}</td>
      <td> {{ props.item.ownership }} </td>
      <td>{{ props.item.is_living_here ? 'Living here': 'Not living here' }}
    </td>
    <v-menu bottom left class="mt-2" v-if="config.UNITS[0].ownership.toLowerCase().includes('tenant') ? props.item.ownership.toLowerCase().includes('tenant') : true">
    <v-btn small icon slot="activator" class="ma-0">.
    <v-icon>more_vert</v-icon>
  </v-btn>
  <v-list>
  <v-list-tile v-if="props.item.is_living_here" @click="updateOcc('not-living-here', props.item)">
  <v-list-tile-avatar><v-icon>close</v-icon></v-list-tile-avatar>
  <v-list-tile-title>Currently not living here</v-list-tile-title>
</v-list-tile>
<v-list-tile @click="updateOcc('living-here', props.item)">
<v-list-tile-avatar><v-icon>check</v-icon></v-list-tile-avatar>
<v-list-tile-title>Living here</v-list-tile-title>
</v-list-tile>
<v-list-tile @click="updateOcc('delete', props.item)">
<v-list-tile-avatar><v-icon>delete</v-icon></v-list-tile-avatar>
<v-list-tile-title>Permanently delete this record</v-list-tile-title>
</v-list-tile>
</v-list>
</v-menu>
</tr>
</template>
</v-data-table>
</v-card> -->

</v-card>
</v-form>
</v-flex>
</v-layout>
</v-container>
</v-tab-item>
<v-divider></v-divider>
<v-tab-item :key="2" v-if="!config.IS_OTHER_USER">
  <v-container class="pa-2" grid-list-md>
    <v-layout>
      <v-flex xs12 sm9 offset-sm3 class="mx-auto">
        <v-data-table v-if="lAction == 'view'"
        :headers="$vuetify.breakpoint.smAndUp ? vehHeadSm : vehHead"
        :items="vehicles"
        hide-actions
        class="elevation-1"
        >
        <template slot="items" slot-scope="props">
          <tr @click="updateVeh(props.item)">
            <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.block_nm + ' ' + props.item.unit_no }}</td>
            <td><v-icon>{{ props.item.veh_type === 'Car' ? 'directions_car' : 'directions_bike' }}</v-icon></td>
            <td>{{ props.item.veh_no }}</td>
            <td>{{ props.item.has_got_sticker ? 'Yes' : 'No' }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-form v-if="lAction != 'view'" ref="frmVeh" @submit.prevent="validateAndSave()">
        <v-card v-if="lAction" class="mt-2">
          <v-card-title v-if="lAction === 'create'" class="title pb-0">Create Vehicle</v-card-title>
          <v-card-title v-if="lAction === 'update'" class="title pb-0">Vehicle Details</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select v-if="config.USER_HAS_MORE_UNITS"
                label="Unit"
                v-model="vehicle.unit_id"
                :items="config.UNITS"
                item-text="block_and_unit"
                item-value="unit_id"
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-select
                label="Type"
                v-model="vehicle.veh_type"
                :items="vehicleTypes"
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                label="Number"
                v-model="vehicle.veh_no"
                :rules="[rules.required]"
                maxlength="15"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-checkbox
                label="Has got parking sticker"
                v-model="vehicle.has_got_sticker"
                >
              </v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn flat @click.native="cancelVeh">Cancel</v-btn>
          <v-btn v-if="lAction === 'update'" flat @click.native="deleteVeh">Delete</v-btn>
          <v-btn flat type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <v-alert v-if="lAction === 'view'" outline class="mt-5" color="info" :value="true">
      <v-card flat color="transparent">
        <v-card-title class="title pb-0">Your declaration helps! How?</v-card-title>
        <v-card-text>
          <ul class="pl-3">
            <li>For better & seamless security checks</li>
            <li>Hasle-free parking management</li>
          </ul>
        </v-card-text>
      </v-card>
    </v-alert>
  </v-flex>
</v-layout>
</v-container>
</v-tab-item>
<v-tab-item :key="3" v-if="!config.IS_OTHER_USER">
  <v-container class="pa-2" grid-list-md>
    <v-layout v-if="dailyHelpAction == 'view'">
      <v-flex xs12 sm9 offset-sm3 class="mx-auto">
        <v-data-table
        :headers="$vuetify.breakpoint.smAndUp ? dhHeadSm : dhHead"
        :items="myDailyHelps"
        hide-actions
        class="elevation-1"
        >
        <template slot="items" slot-scope="props">
          <tr @click="viewDailyHelp(props.item)">
            <td>
              <v-avatar size="45px" slot="activator" class="my-1">
                <img :src="config.STATIC_FILES_DIR + props.item.visitor_img_url"/>
              </v-avatar>
            </td>
            <td>{{ props.item.visitor_name }}</td>
            <td>{{ props.item.visitor_phone }}</td>
            <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.visitor_sub_cat }}</td>
          </tr>
        </template>
      </v-data-table>
      <v-alert outline class="mt-5 pa-2" color="info" :value="true">
        <v-card flat color="transparent">
          <v-card-title class="title pb-0">Daily helpers of your unit!</v-card-title>
          <v-card-text>
            <ul class="pl-3">
              <li>List is updated when security guard adds/deletes a helper behalf your unit</li>
              <li>Don't forget to report/delete when your helper no more works for you</li>
              <li>
                Employing a maid? Click on + button and pick the one from list
              </li>
              <ul>
                <li>Get notified when your helper checks in/out at gate</li>
                <li>For better & seamless security checks</li>
              </ul>
            </ul>
          </v-card-text>
        </v-card>
      </v-alert>
    </v-flex>
  </v-layout>
  <!-- daily helper addition -->
  <v-layout v-else>
    <v-flex xs12 sm9 offset-sm3 class="mx-auto">
      <v-card-title class="px-0 pt-0 pb-1 title">
        <v-btn class="ma-0" icon @click="dailyHelpAction='view'"><v-icon>arrow_back</v-icon></v-btn>
        <v-spacer></v-spacer>
        Add Daily Helper
      </v-card-title>
      <v-expansion-panel>
        <v-expansion-panel-content
        v-for="(item,i) in dailyHelpList.stats"
        :key="i"
        >
        <template v-slot:header>
          <div class="title"><b>{{item.visitor_sub_cat}} ({{item.tot_rec}})</b></div>
        </template>
        <div v-for="(helper,d) in dailyHelpList.detail.filter(rec => rec.visitor_sub_cat === item.visitor_sub_cat)">
          <v-card class="ma-2">
            <v-card-text class="pb-2">
              <v-layout row wrap>
                <v-flex xs3 sm2 md1>
                  <v-avatar size="65px" slot="activator" class="mt-2 grey lighten-4">
                    <img :src="config.STATIC_FILES_DIR + helper.visitor_img_url"/>
                  </v-avatar>
                </v-flex>
                <v-flex xs7 sm9 md10 :class="$vuetify.breakpoint.smAndUp?'pl-3':''">
                  <div class="subheading">
                    <strong>{{helper.visitor_name}}</strong>
                  </div>
                  <div>
                    <span class=" caption info--text">{{helper.visitor_sub_cat.toUpperCase()}}</span>
                    <v-chip small disabled class="caption black--text mx-0">Works in {{helper.tot_linked_units}} unit{{helper.tot_linked_units === 1 ? '' : 's'}}</v-chip>
                  </div>
                  <v-card flat @click="showDailyHelpRating(false, helper)">
                    <v-rating size="20" color="warning" background-color="grey"
                    dense v-model="helper.avg_overall_rating" readonly></v-rating>
                    <div class="info--text caption">
                      <a class="mr-3">{{helper.no_of_rating}} rating{{lRatings.no_of_rating === 1 ? '' : 's'}}</a>
                      <a>{{helper.no_of_review}} review{{helper.no_of_review === 1 ? '' : 's'}}</a>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs2 sm1 md1 class="text-xs-right">
                  <v-btn icon class="mt-4 grey lighten-4"><a style="text-decoration: none;" :href="'tel:' + item.visitor_phone"><v-icon>phone</v-icon></a></v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-if="myDailyHelps.length && myDailyHelps.findIndex(rec => rec.easypass_id === helper.easypass_id) >= 0" class="grey--text caption">Already linked to your unit</div>
              <v-btn v-else small flat @click="addDailyHelper(helper)">Add to my unit</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-flex>
</v-layout>
</v-container>
</v-tab-item>

<v-btn v-if="(tab === 2 && lAction === 'view') || (tab === 3 && dailyHelpAction === 'view')"
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
dark fab fixed
bottom right color="accent"
@click.native="tab === 2 ?createVeh():prepareAddDailyHelp()">
<v-icon>add</v-icon>
</v-btn>

</v-tabs-items>

<v-dialog v-model="viewDailyHelpDlg" max-width="400px" persistent>
  <v-container class="pa-0" grid-list-sm>
    <v-card flat>
      <v-card-title class="pa-0 grey lighten-4">
        <v-spacer></v-spacer>
        <v-btn icon small @click="viewDailyHelpDlg=false"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <v-card-text class="pa-0 text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 class="title">
                {{lDailyHelp.visitor_name}}
              </v-flex>
              <v-flex xs12>
                {{lDailyHelp.visitor_sub_cat}}
              </v-flex>
              <v-flex xs12>
                <v-avatar :size="120" class="grey lighten-4">
                  <img :src="config.STATIC_FILES_DIR + lDailyHelp.visitor_img_url">
                </v-avatar>
              </v-flex>
              <v-flex xs12>
                <v-chip small :disabled="true" class="black--text">Works in {{lDailyHelp.tot_linked_units}} unit{{lDailyHelp.tot_linked_units === 1 ? '' : 's'}}</v-chip>
              </v-flex>
              <v-flex xs12>
                <v-card v-if="lRatings">
                  <v-card-text class="pa-2" @click="showDailyHelpRating(!lRatings.no_of_rating)">
                    <v-rating size="30" color="warning" background-color="grey"
                    dense v-model="lRatings.avg_overall_rating" readonly></v-rating>
                    <div class="info--text caption">
                      <a class="mr-3">{{lRatings.no_of_rating}} rating{{lRatings.no_of_rating === 1 ? '' : 's'}}</a>
                      <a>{{lRatings.no_of_review}} review{{lRatings.no_of_review === 1 ? '' : 's'}}</a>
                    </div>
                  </v-card-text>
                  <div>
                    <v-btn small flat class="caption grey--text" @click="showDailyHelpRating(true)">{{lRatings.myratings ? ('You rated on ' + handy.formatDate(lRatings.myratings.rated_on)) : (lRatings.no_of_rating ? '' : 'Be the first one. ') + 'Review now!'}}<v-icon small class="ml-2">edit</v-icon></v-btn>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="showRepDelDailyHelp()">Report/Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</v-dialog>

<v-dialog v-model="rateDailyHelpDlg" persistent max-width="400px">
  <v-card v-if="beingRated && lRatings">
    <v-card-title class="title grey lighten-4">
      My feedback for {{lDailyHelp.visitor_name}}
    </v-card-title>
    <v-card-text class="pb-0">
      <v-flex xs12>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 md6 class="mt-1">
              <div>Overall satisfaction</div>
            </v-flex>
            <v-flex xs6 md6 class="text-xs-right">
              <v-rating size="25" color="warning" background-color="grey"
              dense
              v-model="rDailyHelp.overall_rating"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-divider class="my-2"></v-divider>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 md6 class="mt-1">
              <div>Skillful</div>
            </v-flex>
            <v-flex xs6 md6 class="text-xs-right">
              <v-rating size="25" color="warning" background-color="grey"
              dense
              v-model="rDailyHelp.skill"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 md6 class="mt-1">
              <div>Regular</div>
            </v-flex>
            <v-flex xs6 md6 class="text-xs-right">
              <v-rating size="25" color="warning" background-color="grey"
              dense
              v-model="rDailyHelp.regular"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 md6 class="mt-1">
              <div>So loyal</div>
            </v-flex>
            <v-flex xs6 md6 class="text-xs-right">
              <v-rating size="25" color="warning" background-color="grey"
              dense
              v-model="rDailyHelp.loyal"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 md6 class="mt-1">
              <div>Easy going person</div>
            </v-flex>
            <v-flex xs6 md6 class="text-xs-right">
              <v-rating size="25" color="warning" background-color="grey"
              dense
              v-model="rDailyHelp.easygoing"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-divider class="mt-2 mb-3"></v-divider>
        <v-flex xs12>
          <v-textarea
          label="Review"
          v-model="rDailyHelp.review"
          hide-actions
          rows="3"
          maxlength="250"
          counter="250"
          placeholder="Optional"
          hint="Your review will be visible to others, not personal details"
          persistent-hint
          ></v-textarea>
        </v-flex>
      </v-flex>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="rateDailyHelpDlg=false">Cancel</v-btn>
      <v-btn flat @click="rateDailyHelp()" class="accent--text">Submit</v-btn>
    </v-card-actions>
  </v-card>
  <v-card v-else-if="lRatings">
    <v-card-title class="title grey lighten-4">
      {{lDailyHelp.visitor_name}} ({{lDailyHelp.visitor_sub_cat}})
      <v-spacer></v-spacer>
      <v-btn class="ma-0" icon small @click="rateDailyHelpDlg=false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 md6 class="mt-1">
              <div>Overall satisfaction</div>
            </v-flex>
            <v-flex xs6 md6 class="text-xs-right">
              <v-rating size="25" color="warning" background-color="grey"
              readonly dense
              v-model="lRatings.avg_overall_rating"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-divider class="my-2"></v-divider>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 md6 class="mt-1">
              <div>Skillful</div>
            </v-flex>
            <v-flex xs6 md6 class="text-xs-right">
              <v-rating size="25" color="warning" background-color="grey"
              readonly dense
              v-model="lRatings.avg_skill"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 md6 class="mt-1">
              <div>Regular</div>
            </v-flex>
            <v-flex xs6 md6 class="text-xs-right">
              <v-rating size="25" color="warning" background-color="grey"
              readonly dense
              v-model="lRatings.avg_regular"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 md6 class="mt-1">
              <div>So loyal</div>
            </v-flex>
            <v-flex xs6 md6 class="text-xs-right">
              <v-rating size="25" color="warning" background-color="grey"
              readonly dense
              v-model="lRatings.avg_loyal"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs6 md6 class="mt-1">
              <div>Easy going person</div>
            </v-flex>
            <v-flex xs6 md6 class="text-xs-right">
              <v-rating size="25" color="warning" background-color="grey"
              readonly dense
              v-model="lRatings.avg_easygoing"></v-rating>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-divider class="mt-2 mb-3"></v-divider>
        <v-flex xs12 v-if="lRatings.no_of_review" class="subheading">
          <div v-for="(rec, i) in lRatings.detail" :key="i">
            <span class="caption grey--text">A review posted on {{handy.formatDate(rec.rated_on)}}
              <v-rating size="15" color="accent" background-color="grey"
              readonly dense
              v-model="rec.overall_rating"></v-rating>
            </span>
            <div>
              <span class="title info--text">"</span><i>{{rec.review}}</i><span class="title info--text">"</span>
            </div>
            <v-divider v-if="i < lRatings.detail.length-1" class="mx-3 my-2"></v-divider>
          </div>
        </v-flex>
        <v-flex xs12 v-else class="text-xs-center caption">
          No reviews yet!
        </v-flex>
      </v-flex>
    </v-card-text>
  </v-card>
</v-dialog>

<v-dialog v-model="repDailyHelpDlg" max-width="400px" persistent>
  <v-card>
    <v-card-title class="title grey lighten-4">{{lDailyHelp.visitor_name}} ({{lDailyHelp.visitor_sub_cat}})</v-card-title>
    <v-card-text class="pt-0">
      <v-radio-group
      v-model="lDailyHelp.rep_del_reason"
      hide-details
      >
      <v-radio
      :label="'Delete as ' + (lDailyHelp.gender==='Female' ? 'she' : 'he') + ' does not work for us any more'"
      value="D"
      >
    </v-radio>
    <v-radio
    :label="'Report & delete as ' + (lDailyHelp.gender==='Female' ? 'she' : 'he') + ' is wrongly linked to our unit'"
    value="R"
    >
  </v-radio>
</v-radio-group>
</v-card-text>
<v-divider></v-divider>
<v-card-actions>
  <v-spacer></v-spacer>
  <v-btn flat @click="repDailyHelpDlg=false">Cancel</v-btn>
  <v-btn flat @click="repDelDailyHelp()" class="accent--text">Submit</v-btn>
</v-card-actions>
</v-card>
</v-dialog>

<v-dialog v-model="vdoDlg" max-width="310px">
  <v-card>
    <v-card-text>
      <video id="cam" style="width:280px; height:210px" autoplay></video>
    </v-card-text>
    <div class="text-xs-center pb-3 pt-0">
      <v-btn icon @click="capturePhoto"><v-icon x-large>camera</v-icon></v-btn>
    </div>
    <div style="position:absolute; top:15px; right:10px">
      <v-btn small color="grey" icon @click.stop="closeVdoDlg"><v-icon small>close</v-icon></v-btn>
    </div>
  </v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="4000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import { login } from '@/utils/auth'
import { VueTelInputVuetify } from 'vue-tel-input-vuetify'

export default {
  props: ['action'],
  components: {
    'vue-tel-input-vuetify': VueTelInputVuetify
  },
  data () {
    return {
      tab: null,
      // tabitems: config.IS_OTHER_USER ? ['Personal'] : ['Personal', 'Unit', 'Daily Helper'],
      tabitems: config.IS_OTHER_USER ? ['Personal'] : ['Personal', 'Unit'],
      sbar: false,
      sbarMsg: '',
      sbarCol: 'info',
      rules: handy.rules,
      handy: handy,
      otp: '',
      config: config,
      beingSaved: false,

      // personal
      profile: {},
      commName: config.COMM_NAME,
      roleName: config.ROLE_NAME,
      avatarURL: !config.AVATAR_URL.includes('base64') ? config.STATIC_FILES_DIR + config.AVATAR_URL : config.AVATAR_URL, // image from db or recently changed cache
      isMC: config.IS_MC_MEMBER,
      isAdmin: config.IS_ADMIN,
      isFM: config.IS_FM,
      isOtherUser: config.IS_OTHER_USER,
      hideContact: config.HIDE_CONTACT,
      vdoDlg: false,
      localMediaStream: null,
      canSendOTP: false,
      isValidNumber: false,
      isValidNumberDailyHelp: false,
      // unit

      unit: {},
      users: [],
      occupants: [],
      // Vehicle
      vehHead: [
        { text: 'Type', value: 'veh_type' },
        { text: 'Vehicle No', value: 'veh_no' },
        { text: 'Sticker?', value: 'has_got_sticker' }
      ],
      vehHeadSm: [
        { text: 'Unit', value: 'unit' },
        { text: 'Type', value: 'veh_type' },
        { text: 'Vehicle No', value: 'veh_no' },
        { text: 'Sticker?', value: 'has_got_sticker' }
      ],
      vehicles: [],
      vehicle: this.getEmptyVeh(),
      lAction: 'view',
      // daily helpers
      dailyHelpSubCat: ['Maid', 'Nanny', 'Driver', 'Cook', 'Others'],
      dhHead: [
        { text: 'Photo', value: 'visitor_img_url' },
        { text: 'Name', value: 'visitor_name' },
        { text: 'Mobile Number', value: 'visitor_phone' }
      ],
      dhHeadSm: [
        { text: 'Photo', value: 'visitor_img_url' },
        { text: 'Name', value: 'visitor_name' },
        { text: 'Mobile Number', value: 'visitor_phone' },
        { text: 'Type', value: 'visitor_sub_cat' }
      ],
      myDailyHelps: [],
      dailyHelpList: [],
      lDailyHelp: {ratings: '', myratings: ''},
      rDailyHelp: '',
      lRatings: '',
      beingRated: false,
      viewDailyHelpDlg: false,
      repDailyHelpDlg: false,
      rateDailyHelpDlg: false,
      dailyHelpAction: 'view',
      userHead: [
        { text: 'Name', value: 'cust_name', width: '250px' },
        { text: 'Ownership', value: 'ownership', width: '25px' },
        { text: 'Status', value: 'rel_status', width: '25px' },
        { text: '', value: 'action' }
      ],
      userHeadSm: [
        { text: 'Photo', value: 'avatar_url' },
        { text: 'Name', value: 'cust_name' },
        { text: 'Mobile', value: 'contact_phone' },
        { text: 'Ownership', value: 'ownership' },
        { text: 'Status', value: 'rel_status' },
        { text: '', value: 'action' }
      ],
      occHeadSm: [
        { text: 'Name', value: 'cust_name' },
        { text: 'Mobile', value: 'contact_phone' },
        { text: 'Ownership', value: 'ownership' },
        { text: 'Status', value: 'rel_status' },
        { text: '', value: 'action' }
      ],
      vehicleTypes: config.COMM_COUNTRY_CODE === 'MY' ? ['Car', 'Motorcycle'] : ['Car', 'Two Wheeler']
    }
  },
  created () {
    var qry = {
      params: {
        user_id: config.USER_ID,
        comm_id: config.COMM_ID
      }
    }
    // load user profile and corresponding details
    this.axios.get(config.API_URL + '/getCustByUserId/', qry)
    .then(response => {
      this.profile = response.data[0]

      // unit details if he is normal resident
      if (!this.isOtherUser) {
        // load user details
        this.loadUsers(config.UNITS[0], 0)
        // load occupancy details
        // this.loadOcc()
        // load vehicle Details
        this.loadVeh()
        // load daily helpers Details. This is not required for app.uniservice.in
        // this.loadMyDailyHelpers()
      }
    })
    .catch(err => {
      this.msg(err.response.data)
    })
  },
  mounted () {
    // default tab
    if (this.action === 'join') { // coming from dashboard to approve joining req
      this.tab = 1
    }
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    pickAvatar () {
      this.$refs.fileInput.click()
    },
    prepareCamera () {
      if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
        alert('Sorry, your browser does not support this feature\nTry using google chrome')
        return
      }

      // start camera and play
      navigator.mediaDevices.getUserMedia({video: true})
      .then(stream => { // success
        this.vdoDlg = true
        document.querySelector('video').srcObject = stream
        this.localMediaStream = stream
      })
      .catch(error => {
        console.error('Webcam access is rejected: ' + error)
      })
    },
    capturePhoto () {
      const canvas = document.createElement('canvas')
      const video = document.querySelector('#cam')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0)
      this.avatarURL = canvas.toDataURL('image/png')
      this.vdoDlg = false
      // stop the camera
      var tracks = this.localMediaStream.getTracks()
      tracks.forEach(function (track) {
        track.stop()
      })
      this.localMediaStream.srcObject = null
    },
    loadAvatarFromFile (event) {
      const files = event.target.files
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.avatarURL = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
    },
    closeVdoDlg () {
      this.vdoDlg = false
    },
    cancelChanges () {
      this.$router.go(-1)
    },
    validateAndSave () {
      // validate and go ahead
      if (this.tab === 0 || this.tab === 1) {
        if (this.tab === 0) {
          setTimeout(() => {
            if (this.$refs.frmPersonal.validate()) {
              // validate OTP in case changed
              this.profile.contact_phone = this.profile.contact_phone.replace(/ /g, '')
              if (config.MOBILE_NO !== this.profile.contact_phone) {
                this.axios.post(config.API_URL + '/otp/verify', {contact_phone: this.profile.contact_phone, purpose: 'joining', otp: this.otp})
                .then(response => {
                  this.saveChanges()
                })
                .catch(err => {
                  this.msg(err.response.data)
                  return
                })
              } else {
                this.saveChanges()
              }
            } else {
              this.msg('Enter the required values highlighted above')
            }
          }, 500)
        } else {
          if (this.$refs.frmUnit.validate()) {
            this.saveChanges()
          }
        }
      } else {
        this.saveChanges() // validate happens in save changes
      }
    },
    saveChanges (curUnit, isRentedChange = false) {
      // 1. update personal/unit details
      if (this.tab === 0) {
        // validation already happened in above function
        this.profile.comm_id = config.COMM_ID
        this.profile.is_other_user = config.IS_OTHER_USER
        this.profile.is_mc_member = config.IS_MC_MEMBER
        this.profile.hide_contact = this.hideContact
        this.profile.avatar_url = this.avatarURL
        this.profile.is_self_service = true
        this.beingSaved = true
        this.axios.post(config.API_URL + '/resident/update', this.profile)
        .then(response => {
          this.msg('Saved successfully', 1)

          // refresh cache
          config.CUST_NAME = this.profile.cust_name
          config.EMAIL_ID = this.profile.contact_email
          config.HIDE_CONTACT = this.hideContact
          config.AVATAR_URL = this.avatarURL
          // check for mobile number change - relogin
          if (config.MOBILE_NO !== this.profile.contact_phone) {
            this.otp = ''
            config.MOBILE_NO = this.profile.contact_phone
            login(config.USER_ID, config.MOBILE_NO)
            // delete the temporary joinee record
            this.axios.post(config.API_URL + '/otp/delete-joinee', {contact_phone: this.profile.contact_phone})
          }
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      } else if (this.tab === 1) {
        // 1.1 unit properties
        if (isRentedChange && !curUnit.is_rented && this.users[curUnit.unit_id] && this.users[curUnit.unit_id].findIndex(rec => rec.ownership.toLowerCase().includes('tenant') && rec.rel_status === 'Linked') >= 0) {
          if (!confirm('WARNING: This action will delink all your tenants and revoke their access from this house automatically')) {
            curUnit.is_rented = true // reverse the change
            this.$forceUpdate()
            return
          }
        }
        curUnit.is_self_service = true
        curUnit.user_id = config.USER_ID
        curUnit.is_billed_to_tenant = curUnit.is_rented ? curUnit.is_billed_to_tenant : false
        this.axios.post(config.API_URL + '/unit/update', curUnit)
        .then(response => {
          this.refreshUnitDet()
        })
        .catch(err => {
          this.msg(err.response.data)
        })
      } else if (this.tab === 2) {
        // 2. vehicle
        if (this.$refs.frmVeh.validate() || this.lAction === 'delete') {
          this.vehicle.comm_id = config.COMM_ID
          this.vehicle.user_id = config.USER_ID
          this.beingSaved = true
          this.axios.post(config.API_URL + '/vehicle/' + this.lAction, this.vehicle)
          .then(response => {
            // refresh list and go back
            this.loadVeh()
            this.lAction = 'view'
            this.beingSaved = false
          })
          .catch(err => {
            this.msg(err.response.data)
            this.beingSaved = false
          })
        }
      }
    }, // save changes

    sendOTP () {
      if (!this.isValidNumber) {
        this.msg('Invalid mobile number')
        return
      }
      this.profile.contact_phone = this.profile.contact_phone.replace(/ /g, '')
      // validate for fresh user if user wishes to change his/her mobile no
      var qry = {
        params: {
          user_id: config.USER_ID,
          contact_phone: this.profile.contact_phone
        }
      }
      this.profile.contact_phone = this.profile.contact_phone.substring(0, 15)
      if (this.profile.contact_phone !== config.MOBILE_NO) {
        this.axios.get(config.API_URL + '/getUserByPhone/', qry)
        .then(response => {
          if (response.data.length > 0) {
            this.msg('Another user already exist with this mobile number')
            return
          } else {
            // send otp
            this.axios.post(config.API_URL + '/otp/send', {contact_phone: this.profile.contact_phone, purpose: 'joining', country_code: config.COMM_COUNTRY_CODE})
            .then(response => {
              this.msg('An OTP is sent to your mobile. Please check and enter here', 2)
            })
            .catch(err => {
              this.msg(err.response.data)
            })
          }
        })
      }
    }, // send OTP
    loadUsers (curUnit, idx) {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          unit_id: curUnit.unit_id
        }
      }
      // load users of all units belong to this user
      this.axios.get(config.API_URL + '/getUserByUnitId/', qry)
      .then(response => {
        this.users[curUnit.unit_id] = response.data
        this.$forceUpdate()
        // recurse through all units
        if (idx < config.UNITS.length - 1) {
          ++idx
          this.loadUsers(config.UNITS[idx], idx)
        }
      })
      .catch(err => {
        this.msg(err.response.data)
        this.users[curUnit.unit_id] = []
      })
    },
    acceptRejReq (curAct, curUser, curUnit) {
      if (curAct === 'accept-req' && curUser.ownership.toLowerCase().includes('tenant') && !curUnit.is_rented) {
        if (!confirm('Please note that the house will be marked as rented upon accepting tenant\'s joining request')) {
          return
        }
      }
      // accept or reject
      curUser.actioned_by = config.USER_ID
      this.axios.post(config.API_URL + '/admin/' + curAct, curUser)
      .then(response => {
        // refresh list in front end
        if (curAct === 'reject-req') {
          curUser.rel_status = 'Rejected'
        } else {
          curUser.rel_status = 'Linked'
          if (curUser.ownership.toLowerCase().includes('tenant')) {
            curUnit.is_rented = true
          }
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    userUpdate (curAct, curUser, curUnit) {
      if (curAct === 'delink') {
        var warnText = ''
        if (curUser.user_id === config.USER_ID) {
          warnText = 'Sure, you want to disassociate yourself from unit "' + curUser.unit_no + '"?'
          warnText += '\nWARNING: If you do so, you might not be able log into app at all'
        } else {
          warnText = 'Sure, you want to disassociate the user from unit "' + curUser.unit_no + '"?'
          warnText += '\nWARNING: If you do so, user might not be able log into app at all'
        }
        if (!confirm(warnText)) {
          return
        }
      } else if (curUser.ownership.toLowerCase().includes('tenant') && !curUnit.is_rented) {
        if (!confirm('Please note that the house will be marked as rented upon linking the tenant')) {
          return
        }
      }

      // link or delink
      curUser.actioned_by = config.USER_ID
      this.axios.post(config.API_URL + '/admin/' + curAct, curUser)
      .then(response => {
        // refresh list in front end
        if (curAct === 'delink') {
          curUser.rel_status = 'Delinked'
        } else {
          curUser.rel_status = 'Linked'
          if (curUser.ownership.toLowerCase().includes('tenant')) {
            curUnit.is_rented = true
          }
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },

    /* all functions related to vehicle */

    getEmptyVeh () {
      return {
        veh_id: '',
        unit_id: config.UNITS[0].unit_id,
        veh_type: '',
        veh_no: '',
        has_got_sticker: false
      }
    },
    loadVeh () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          unit_id_list: config.UNIT_ID_LIST
        }
      }
      this.axios.get(config.API_URL + '/getVehiclesByUnitIds/', qry)
      .then(response => {
        this.vehicles = response.data
      })
    },
    createVeh () {
      this.lAction = 'create'
      // get ready for create with empty vehicle
      this.vehicle = this.getEmptyVeh()
    },
    updateVeh (item) {
      // load chosen vehicle for update
      this.vehicle = Object.assign({}, item)
      this.lAction = 'update'
    },
    cancelVeh () {
      // refresh the list
      this.loadVeh()
      this.lAction = 'view'
    },
    deleteVeh () {
      // confirm
      if (confirm('Sure, you want to delete the vehicle "' + this.vehicle.veh_no + '"?')) {
        // delete
        this.lAction = 'delete'
        this.validateAndSave()
      }
    },

    /* all functions related to daily helper */
    loadMyDailyHelpers () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          unit_id_list: config.PRIVATE_UNIT_ID_LIST
        }
      }
      this.axios.get(config.API_URL + '/getDailyHelperByUnitIds/', qry)
      .then(response => {
        this.myDailyHelps = response.data
      })
    },
    prepareAddDailyHelp () {
      // get ready for adding a daily helper
      // load daily helpers of this community
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getDailyHelperByCommId/', qry)
      .then(response => {
        this.dailyHelpList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.dailyHelpList = []
      })
      this.dailyHelpAction = 'add'
    },
    refreshUnitDet () {
      // users unit (one or more in this community)
      this.axios.get(config.API_URL + '/getUnitsByUserId/' + config.USER_ID + '/' + config.COMM_ID)
      .then(response => {
        config.UNITS = response.data

        // check user has more than one unit in this community
        config.USER_HAS_MORE_UNITS = config.UNITS.length > 1
        config.UNIT_ID_LIST = config.UNITS.filter(rec => rec.rel_status === 'Linked')
        if (config.UNIT_ID_LIST.length) {
          config.UNIT_ID_LIST = config.UNIT_ID_LIST.map(rec => rec.unit_id)
        }

        // list of units which needs privacy (used mostly in security module)
        config.PRIVATE_UNIT_ID_LIST = []
        config.UNITS.forEach(unit => {
          if (unit.is_rented) {
            if (unit.ownership.toLowerCase().includes('tenant')) {
              // rented units are private to tenants
              config.PRIVATE_UNIT_ID_LIST.push(unit.unit_id)
            }
          } else {
            // not-rented, not private to anyone
            config.PRIVATE_UNIT_ID_LIST.push(unit.unit_id)
          }
        })
        config.USER_HAS_MORE_PRIVATE_UNITS = config.PRIVATE_UNIT_ID_LIST.length > 1
      })
      .catch(error => {
        alert(error.response.data)
        return
      })
    },
    ignoreBackspace (e) {
      if (e.key === 'Backspace') {
        const start = this.profile.contact_phone.length - 1
        this.profile.contact_phone = this.profile.contact_phone.substring(0, start)
        e.preventDefault()
      }
    },
    keepCursor () {
      this.$refs.refMob.cursorPosition = this.profile.contact_phone.length
    },
    validateMob ({ number, valid, country }) {
      this.isValidNumber = valid
      if (valid) {
        this.profile.contact_phone = number.e164
        this.profile.phone_country = country.name && country.name.includes('(') ? country.name.substring(0, country.name.indexOf('(') - 1) : country.name
      }
    },
    viewDailyHelp (curDailyHelp) {
      this.lDailyHelp = Object.assign({}, curDailyHelp)
      // load ratings of this daily helper
      this.loadDailyHelpRatings(this.lDailyHelp)
      this.viewDailyHelpDlg = true
    },
    loadDailyHelpRatings (curHelper) {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          easypass_id: curHelper.easypass_id
        }
      }
      this.axios.get(config.API_URL + '/getDailyHelperRatings/', qry)
      .then(response => {
        this.lRatings = {}
        this.lRatings.detail = response.data
        this.lRatings.myratings = response.data.find(rec => rec.user_id === config.USER_ID)
        // stats
        this.lRatings.no_of_rating = this.lRatings.detail.length
        this.lRatings.no_of_review = this.lRatings.detail.filter(rec => rec.review).length
        this.lRatings.avg_overall_rating = this.lRatings.detail.map(rec => rec.overall_rating).reduce((a, b) => a + b, 0) / this.lRatings.detail.length
        this.lRatings.avg_skill = this.lRatings.detail.map(rec => rec.skill).reduce((a, b) => a + b, 0) / this.lRatings.detail.length
        this.lRatings.avg_regular = this.lRatings.detail.map(rec => rec.regular).reduce((a, b) => a + b, 0) / this.lRatings.detail.length
        this.lRatings.avg_loyal = this.lRatings.detail.map(rec => rec.loyal).reduce((a, b) => a + b, 0) / this.lRatings.detail.length
        this.lRatings.avg_easygoing = this.lRatings.detail.map(rec => rec.easygoing).reduce((a, b) => a + b, 0) / this.lRatings.detail.length
        this.$forceUpdate()
      })
    },
    showDailyHelpRating (isRated, curHelper = '') {
      if (curHelper) {
        // show ratings of requested helper
        this.loadDailyHelpRatings(curHelper)
        this.beingRated = false
      } else {
        // show ratings of helper being viewed (lDailyHelp)
        if (isRated) {
          this.beingRated = true
          this.rDailyHelp = this.lRatings.myratings || {}
          this.rDailyHelp.user_already_rated = this.lRatings.myratings && this.lRatings.myratings.overall_rating
          this.rDailyHelp.user_id = config.USER_ID
          this.rDailyHelp.easypass_id = this.lDailyHelp.easypass_id
          this.rDailyHelp.rated_on = handy.formatDBDate(new Date())
        } else {
          this.beingRated = false
        }
      }
      this.rateDailyHelpDlg = true
    },
    rateDailyHelp () {
      this.rDailyHelp.comm_id = config.COMM_ID
      this.axios.post(config.API_URL + '/daily-helper/rate', this.rDailyHelp)
      .then(response => {
        // refresh front end
        this.rateDailyHelpDlg = false
        this.viewDailyHelp(this.lDailyHelp)
      })
      .catch(err => {
        console.log(err)
        this.msg(err.response.data)
      })
    },
    showRepDelDailyHelp () {
      this.lDailyHelp.rep_del_reason = 'D'
      this.repDailyHelpDlg = true
    },
    repDelDailyHelp () {
      // confirm
      if (confirm('Sure, you want to delete "' + this.lDailyHelp.visitor_name + '"?')) {
        this.axios.post(config.API_URL + '/daily-helper/delete', {easypass_id: this.lDailyHelp.easypass_id, unit_id: this.lDailyHelp.unit_id, comm_id: config.COMM_ID, user_id: config.USER_ID})
        .then(response => {
          // refresh front end
          this.repDailyHelpDlg = false
          this.viewDailyHelpDlg = false
          this.loadMyDailyHelpers()
        })
        .catch(err => {
          this.msg(err.response.data)
        })
      }
    },
    addDailyHelper (curHelper) {
      if (confirm('Sure, you want to add "' + curHelper.visitor_name + '" to your unit?')) {
        this.axios.post(config.API_URL + '/daily-helper/add', {easypass_id: curHelper.easypass_id, unit_id: config.PRIVATE_UNIT_ID_LIST[0], comm_id: config.COMM_ID, user_id: config.USER_ID})
        .then(response => {
          // refresh front end
          this.loadMyDailyHelpers()
          this.dailyHelpAction = 'view'
        })
        .catch(err => {
          this.msg(err.response.data)
        })
      }
    }
  } // methods
}
</script>



// WEBPACK FOOTER //
// Profile.vue?3e46343e